<template>
  <section class="section-template" :class="{ [`section-${theme}`]: theme }">
    <div class="section-header" :style="{ '--header-spacing': headerSpacing }">
      <h3 v-if="subTitle" class="sub-title">{{ subTitle }}</h3>
      <Text :variant="titleFontSize" class="title">
        {{ title }}
      </Text>
      <Text v-if="desc" :variant="descFontSize" class="desc">{{ desc }}</Text>
    </div>
    <div class="section-content">
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
import { Text } from '@rendora/design/components/text';
import { useBreakpoint } from '@rendora/design/index';
const headers = useRequestHeaders();
const { isMobile } = useBreakpoint(headers?.['user-agent']);

const titleFontSize = computed(() => (isMobile.value ? '24' : '48'));
const descFontSize = computed(() => (isMobile.value ? '14' : '16'));
defineProps<{
  title: string;
  subTitle?: string;
  desc?: string;
  theme?: 'light' | 'dark';
  headerSpacing?: string;
}>();
</script>
<!-- TODO section 移动端样式确定 -->
<style lang="scss" scoped src="./styles/pc.scss" />
<style lang="scss" scoped src="./styles/mobile.scss" />
